// Module
var code = `<div class="auth-container"> <form> <h1 class="heading">Sign in</h1> <div id="auth-fields"></div> <component-button></component-button> <footer class="auth-link" id="auth-toggle"> <span>Don't have an account?</span> <button>Register</button> </footer> </form> </div> `;
// Exports
export default code;